import React from 'react';
import Slider from 'react-slick';


const testimonials = [
    { id: 1, img: '01.png', title: 'Detour - Canvas Print', price: '$200', name: 'Brooklyn Simmons', description: 'WordPress', review: 'Financial planners help people gain knowledge about how to invest and save their money in the most efficient way ever.' },
    { id: 2, img: '02.png', title: 'Detour - Canvas Print', price: '$200', name: 'Brooklyn Simmons', description: 'WordPress', review: 'Financial planners help people gain knowledge about how to invest and save their money in the most efficient way ever.' },
    { id: 3, img: '03.png', title: 'Detour - Canvas Print', price: '$200', name: 'Brooklyn Simmons', description: 'WordPress', review: 'Financial planners help people gain knowledge about how to invest and save their money in the most efficient way ever.' },
    { id: 4, img: '01.png', title: 'Detour - Canvas Print', price: '$200', name: 'Brooklyn Simmons', description: 'WordPress', review: 'Financial planners help people gain knowledge about how to invest and save their money in the most efficient way ever.' }
];

const PrevArrow = ({ onClick }) => {
    return (
        <button type="button" className="slick-prev slick-arrow" onClick={onClick}>
            <i className="flaticon-left-chevron" />
        </button>
    );
};

const NextArrow = ({ onClick }) => {
    return (
        <button type="button" className="slick-next slick-arrow" onClick={onClick}>
            <i className="flaticon-chevron" />
        </button>
    );
};

const settings = {
    dots: true,
    infinite: true,
    prevArrow: <PrevArrow />, // Add custom prev arrow
    nextArrow: <NextArrow />, // Add custom next arrow
    margin: 30,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ]
};

const Testimonial = () => {
    return (
        <section id="testimonial-seven" className="testimonial-seven-main-block">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="section">
                            <h2 className="section-heading">Pioneering new solutions for your business</h2>
                        </div>
                    </div>
                </div>
                <Slider {...settings} className="testimonial-seven-autoplay">
                    {testimonials.map(({ id, img, title, price, name, description, review }) => (
                        <div key={id} className="testimonial-seven-block">
                            <div className="row align-items-center">
                                <div className="col-lg-4 col-4">
                                    <div className="testimonial-seven-img">
                                        <img src={`/assets/images/home_page_7/testimonial/${img}`} className="img-fluid" alt={title} />
                                    </div>
                                </div>
                                <div className="col-lg-8 col-8">
                                    <ul>
                                        {[...Array(5)].map((_, i) => (
                                            <li key={i}><i className="flaticon-star" /></li>
                                        ))}
                                    </ul>
                                    <h5 className="testimonial-seven-title">{title}</h5>
                                    <p className="testimonial-seven-price">{price}</p>
                                </div>
                            </div>
                            <div className="testimonial-seven-dtl">
                                <p>{review}</p>
                                <h5 className="testimonial-seven-name">{name}</h5>
                                <p className="testimonial-des">{description}</p>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
};

export default Testimonial;
